const Style = {

  loading: 'opacity-50',
  button: 'inline-block mr-[2%] last:mr-0 text-slate-500 whitespace-nowrap'

}

export default Style;